/** @jsx jsx */
import React from 'react'
import { Col, Row } from '@uswitch/ev-core/react'
import { jsx, useThemeUI } from 'theme-ui'
import withComponentBase from '../helpers/with-component-base'
import ConnectedGuideCard from './connected-guide-card'

const ReadMoreModule = ({ linkedUrls }) => {
  const { theme } = useThemeUI()

  return (
    <div sx={{ width: '100%' }}>
      <If condition={linkedUrls}>
        <Row cols={theme?.compounds?.card?.itemsPerRow} wrap>
          <For index='key' each='url' of={linkedUrls}>
            <Col span={1} key={key}>
              <ConnectedGuideCard entity={url} showDescription />
            </Col>
          </For>
        </Row>
      </If>
    </div>
  )
}

export default withComponentBase(ReadMoreModule, {
  withHeaderFooter: true,
  headerStyles: {
    mt: 'lg',
  },
  footerStyles: {
    mb: 'lg',
  },
})
